<template>
  <div class="w-1/2 min-w-contact max-w-full">
    <div class="w-3/5">
      <div>
        <h3 class="text-3xl font-regular-bold mb-10">
          Heb je vragen of wil je een offerte aanvragen?
        </h3>
        <h4 class="text-2xl font-light">
          Twijfel dan niet om contact met me op te nemen.
        </h4>
      </div>
      <div class="mt-16 font-light leading-loose">
        <p>Sil Van Hove:</p>
        <p>+32 487 85 96 64</p>
        <p class="mt-4">Dorpsstraat 5,</p>
        <p>Peer 3990</p>
        <p class="mt-8">VAT</p>
        <p>BE0689592202</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact-text',
};
</script>
